import React from "react";
import { useFormikContext } from "formik";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress";

import FieldsSettingsList from "./FieldsSettingsList";
import useAuth from "../../../hooks/useAuth";

export default function FieldsSettings({
  project,
  activeTab,
  storageEnabled,
  originEnabled,
  destinationEnabled,
  ordersTableFieldsEnabled,
  reservationsTableFieldsEnabled,
  onNext,
  onBack,
  isLastStep,
}) {
  const { user } = useAuth();
  const { settings } = user.company;
  const { isSubmitting, handleSubmit } = useFormikContext();
  const receivingWizardEnabled = settings.receiving_wizard && storageEnabled;

  return (
    <>
      <DialogContent sx={{ bgcolor: "#f4f6f8" }}>
        <FieldsSettingsList
          project={project}
          activeTab={activeTab}
          storageEnabled={storageEnabled}
          originEnabled={originEnabled}
          destinationEnabled={destinationEnabled}
          ordersTableFieldsEnabled={ordersTableFieldsEnabled}
          reservationsTableFieldsEnabled={reservationsTableFieldsEnabled}
          receivingWizardEnabled={receivingWizardEnabled}
          advancedOptionsEnabled={true}
        />
      </DialogContent>
      <DialogActions sx={{ bgcolor: "#f4f6f8" }}>
        <Box display="flex" gap={1} mx={2} my={1}>
          {activeTab > 1 && (
            <Button onClick={onBack} variant="outlined" color="primary">
              Back
            </Button>
          )}
          {isLastStep ? (
            <Button
              disabled={isSubmitting}
              startIcon={isSubmitting && <CircularProgress size={22} />}
              onClick={handleSubmit}
              variant="contained"
              color="primary"
            >
              Save
            </Button>
          ) : (
            <Button onClick={onNext} variant="contained" color="primary">
              Next
            </Button>
          )}
        </Box>
      </DialogActions>
    </>
  );
}
